import ApiWrapper from './api/api-wrapper';

export const createCheckoutSession = async (amount, billingId, cartItems) => {
  try {
    const amountInCents = Math.round(amount * 100);
    
    const { data } = await ApiWrapper.createCheckoutSession({
      amount: amountInCents,
      billingId,
      successUrl: `${window.location.origin}/?success=true&session_id={CHECKOUT_SESSION_ID}&lineItems=${encodeURIComponent(JSON.stringify(cartItems))}`,
      cancelUrl: `${window.location.origin}/?error=true`,
    });

    return data.url;
  } catch (err) {
    console.log('err createCheckoutSession', err);
    return '';
  }
};
